var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#15BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29012 13.9129L3.96 5.08837C3.94421 5.05587 3.93692 5.01989 3.93882 4.9838C3.94071 4.94771 3.95172 4.91269 3.97083 4.88201C3.98993 4.85133 4.0165 4.826 4.04805 4.80838C4.0796 4.79076 4.11511 4.78142 4.15125 4.78125H5.652C5.73243 4.78125 5.80781 4.82625 5.84325 4.89713L9.00562 11.2989C9.28687 11.8727 10.1031 11.8727 10.3849 11.2989L13.5371 4.90219C13.5553 4.86718 13.5828 4.83785 13.6165 4.81741C13.6502 4.79697 13.6889 4.78621 13.7284 4.78631H13.9151C14.0259 4.78631 14.0962 4.90219 14.0462 4.99781L9.66993 13.9134C9.38812 14.4872 8.5725 14.4872 8.29012 13.9134V13.9129Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet);
export default __webpack_public_path__ + "static/media/vet.8285a5fa94eb8488102dc07a45d844e1.svg";
export { ForwardRef as ReactComponent };